import { useEffect, useState } from 'react'

/**
 * Subscribes to a CSS media query. Defaults to `false` when `window` is unavailable (SSR / tests).
 */
export function useMatchMedia(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return false
    }
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return
    const mql = window.matchMedia(query)
    const sync = () => setMatches(mql.matches)
    sync()
    mql.addEventListener('change', sync)
    return () => mql.removeEventListener('change', sync)
  }, [query])

  return matches
}

/** Tailwind `md` breakpoint — incident time wheel is shown below this width. */
export const INCIDENT_TIME_MOBILE_MEDIA_QUERY = '(max-width: 767px)'
